var _g, _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIconWonderblocks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_235_13850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 23.1634 23.1634 16 32 16H100C108.837 16 116 23.1634 116 32V100C116 108.837 108.837 116 100 116H32C23.1634 116 16 108.837 16 100V32Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 10.5263,
    height: 40,
    rx: 1,
    fill: "#0B202C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7368,
    y: 60.7373,
    width: 25.2632,
    height: 25.2632,
    rx: 1,
    fill: "#0B202C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7368,
    y: 46,
    width: 25.2632,
    height: 10.5263,
    rx: 1,
    fill: "#0B202C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_235_13850",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_235_13850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_235_13850",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconWonderblocks);
export default __webpack_public_path__ + "static/media/modal-icon-wonderblocks.f03cb28651d0ed45d8dd31cf16db7f09.svg";
export { ForwardRef as ReactComponent };